export const isEmptyString = (value) => {
    return value === undefined || value === ''
};
